import { render, staticRenderFns } from "./assessment-start.vue?vue&type=template&id=e4a5e004&scoped=true"
import script from "./assessment-start.vue?vue&type=script&lang=js"
export * from "./assessment-start.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a5e004",
  null
  
)

export default component.exports